import { type APPLICANT_ATTRIBUTION_BOTH_TYPE, LOAN_REQUEST_COMMANDS } from 'cpool-constants';

import { DISPOSITIONSKREDIT } from '../../../types';
import { CreditLineLoanFields } from '../shared/CreditLineLoanFields';

type Props = {
    index: number;
    applicant: APPLICANT_ATTRIBUTION_BOTH_TYPE;
};

export const LoanForm: React.FC<Props> = ({ applicant, index }) => (
    <CreditLineLoanFields
        type={DISPOSITIONSKREDIT}
        index={index}
        applicant={applicant}
        commandName={LOAN_REQUEST_COMMANDS.changeLiabilityOverdraft}
    />
);
